const createElementViewUrl = ({ parentId, fileName, elementId }) => {
    return `/ElementView/${parentId}/fileName/${fileName}/elementId/${elementId}`
}

const createViewEditUrl = ({ parentId, viewId, fileName }) => {
    return `/ViewEdit/${parentId}/view/${viewId}/fileName/${fileName}`
}

export { createElementViewUrl, createViewEditUrl }
